export default "__VITE_ASSET__79vo9OKz__"